import React from 'react';
import { Instagram, ExternalLink, Stethoscope, Baby, Salad, Dumbbell, Leaf, HeartPulse } from 'lucide-react';

const accounts = [
  { handle: '@tcubefitness', label: 'TCubeFitness', url: 'https://www.instagram.com/tcubefitness/' },
  { handle: '@layman_doctor', label: 'Layman Doctor', url: 'https://www.instagram.com/layman_doctor/' }
];

const placeholderTiles = [
  { gradient: 'from-blue-500/30 to-cyan-500/30', icon: Stethoscope },
  { gradient: 'from-pink-500/30 to-rose-500/30', icon: Baby },
  { gradient: 'from-emerald-500/30 to-green-500/30', icon: Salad },
  { gradient: 'from-orange-500/30 to-amber-500/30', icon: Dumbbell },
  { gradient: 'from-purple-500/30 to-fuchsia-500/30', icon: Leaf },
  { gradient: 'from-cyan-500/30 to-blue-500/30', icon: HeartPulse }
];

const InstagramSection = () => {
  return (
    <section
      className="py-16 sm:py-20 relative overflow-hidden bg-slate-950"
      data-testid="instagram-section"
    >
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-pink-500/10 border border-pink-500/30 rounded-full text-pink-400 text-sm font-medium mb-4">
            <Instagram className="w-4 h-4" aria-hidden="true" />
            Instagram
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Follow Our <span className="bg-gradient-to-r from-pink-400 to-rose-400 bg-clip-text text-transparent">Journey</span>
          </h2>
          <div className="flex flex-wrap items-center justify-center gap-3 mt-4">
            {accounts.map((a) => (
              <a
                key={a.handle}
                href={a.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-slate-800/60 hover:bg-slate-700/60 border border-slate-700 rounded-full text-slate-300 text-sm transition-colors"
                data-testid={`instagram-handle-${a.handle.replace('@', '')}`}
              >
                <Instagram className="w-4 h-4 text-pink-400" aria-hidden="true" />
                {a.label} <span className="text-slate-500">{a.handle}</span>
              </a>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-6 gap-2 sm:gap-3 max-w-5xl mx-auto mb-8">
          {placeholderTiles.map((t, i) => {
            const TileIcon = t.icon;
            return (
              <div
                key={i}
                className={`aspect-square rounded-xl bg-gradient-to-br ${t.gradient} border border-slate-800 flex items-center justify-center`}
                aria-hidden="true"
                data-testid={`instagram-tile-${i}`}
              >
                <TileIcon className="w-8 h-8 sm:w-10 sm:h-10 text-white/80" strokeWidth={1.5} aria-hidden="true" />
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <a
            href="https://www.instagram.com/tcubefitness/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-600 to-rose-600 hover:from-pink-500 hover:to-rose-500 text-white px-6 py-3 rounded-full font-semibold text-sm sm:text-base transition-all shadow-lg shadow-pink-500/25"
            data-testid="instagram-follow-btn"
          >
            <Instagram className="w-5 h-5" aria-hidden="true" />
            Follow Us on Instagram
            <ExternalLink className="w-4 h-4" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramSection;
